import { ReactNode } from 'react';
import Masonry from 'react-masonry-css';

import css from './Masonry.module.scss';

export type BreakpointColumns =
  | number
  | { default: number; [key: number]: number }
  | { [key: number]: number };

interface IProps {
  breakpointColumns: BreakpointColumns;
  children: ReactNode;
}

export default function MasonryGrid({ breakpointColumns, children }: IProps) {
  return (
    <Masonry
      breakpointCols={breakpointColumns}
      className={css.grid}
      columnClassName={css.gridColumn}
    >
      {children}
    </Masonry>
  );
}
